import { combineReducers } from 'redux';
import {
  LIBRARY_DISCOUNT_SET_OUTLETS,
  LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL,
  LIBRARY_DISCOUNT_SET_DISCOUNTS,
  LIBRARY_DISCOUNT_SET_CURRENT_PAGE,
  LIBRARY_DISCOUNT_SET_TOTAL_PAGE,
  LIBRARY_DISCOUNT_UNSET_DISCOUNT,
  LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT,
  LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL,
  LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL,
  LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT,
  LIBRARY_DISCOUNT_IS_SUBMITTING_FORM,
} from 'actions/library/discount/constants';

import createReducer from 'utils/createReducer';

const currentPage = createReducer(null, {
  [LIBRARY_DISCOUNT_SET_CURRENT_PAGE]: (draft, { payload }) =>
    payload.currentPage,
});

const deletedDiscount = createReducer(null, {
  [LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT]: (draft, { payload }) =>
    payload.deletedDiscount,
});

const discountDetail = createReducer(null, {
  [LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT]: () => null,

  [LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL]: (draft, { payload }) =>
    payload.discount,

  [LIBRARY_DISCOUNT_UNSET_DISCOUNT]: () => null,
});

const discounts = createReducer([], {
  [LIBRARY_DISCOUNT_SET_DISCOUNTS]: (draft, { payload }) => payload.discounts,
});

const isSubmittingForm = createReducer(false, {
  [LIBRARY_DISCOUNT_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,
});

const newDiscount = createReducer(null, {
  [LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT]: () => true,
  [LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL]: () => false,
  [LIBRARY_DISCOUNT_UNSET_DISCOUNT]: () => null,
});

const outlets = createReducer([], {
  [LIBRARY_DISCOUNT_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const showDeleteDiscountModal = createReducer(false, {
  [LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL]: () => true,
  [LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL]: () => false,
});

const showDetail = createReducer(false, {
  [LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT]: () => true,
  [LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL]: () => true,
  [LIBRARY_DISCOUNT_UNSET_DISCOUNT]: () => false,
});

const totalPage = createReducer(null, {
  [LIBRARY_DISCOUNT_SET_TOTAL_PAGE]: (draft, { payload }) => payload.totalPage,
});

export default combineReducers({
  currentPage,
  deletedDiscount,
  discountDetail,
  discounts,
  isSubmittingForm,
  newDiscount,
  outlets,
  showDeleteDiscountModal,
  showDetail,
  totalPage,
});
